import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuid } from 'uuid';
import type { ILayerProps, IWatermarkLayerProps } from '@/version-types';
import { LayerType, MaterialIdsType } from '../enum';

export const WATERMARK_TEXTS_MAX = 4;
export const WATERMARK_DEFAULT_SIZE = 10;
export const WATERMARK_DEFAULT_SPACING = 20;
export const WATERMARK_DEFAULT_CROSS = 0;

export const WATERMARK_LAYER_TYPE = 'watermark_layer_type';

// 全屏参数
export enum FULL_SCREEN_TYPE {
    SIZE = 'size', //大小
    SPACE = 'space', //间距
    CROSS = 'crisscross', //交错
    OFFSET_X = 'offsetX', //水平偏移
    OFFSET_Y = 'offsetY', //垂直偏移
    ROTATE = 'evolve', //旋转
}

export enum WATERMARK_TYPE {
    IMG = 'img',
    TEXT = 'text',
}

const defaultWatermarkLayerData = {
    id: uuid(),
    layerType: LayerType.WATERMARK,
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    rotate: 0,
    opacity: 1,
    title: '',
    materialIds: {},
    fitWidth: 0,
    fitHeight: 0,
    data: {
        // 用户自定义上传的水印图片地址
        originUrl: '',
        // 水印图片地址,为底层生成图片的地址
        url: '',
        // 文字素材包地址
        zipUrl: '',
        // 是否全屏水印
        isFullScreen: false,
        // 横向位移
        offsetX: 0,
        // 纵向位移
        offsetY: 0,
        // 水印大小
        size: 0,
        // 间距
        space: 0,
        // 交错
        cross: 0,
        // 文字内容，有url时为空
        texts: [],
        // 文字颜色#FFFFFFFF，有url时为空
        textColor: '',
        // 字体，有url时为空
        fontFamily: '',
        isColorApplyToAll: false,
    },
    lock: false,
    children: [],
    shine: true,
    hidden: false,
} as ILayerProps;

export const getDefaultWatermarkLayerData = (
    type: WATERMARK_TYPE,
    url?: string,
    textProps?: {
        materialId: string;
        zipUrl: string;
    },
) => {
    const watermarkLayerData = cloneDeep(defaultWatermarkLayerData);
    const data = watermarkLayerData.data as IWatermarkLayerProps;
    if (type === 'text') {
        data.zipUrl = textProps?.zipUrl || '';
    } else {
        data.originUrl = url || '';
    }
    watermarkLayerData.id = uuid();
    watermarkLayerData.materialIds = watermarkLayerData.materialIds || {};
    if (textProps?.materialId) watermarkLayerData.materialIds[MaterialIdsType.WATERMARK] = [textProps.materialId];
    return watermarkLayerData;
};
